import React, { useState } from 'react';
import ActivityLoader from '../Common/ActivityLoader';
import BsModal from '../Common/BsModal';
import { useTheme } from '../../DataStore/ThemeContext';
import Notification from '../Common/Notification';
import ajaxPeriod from '../../util/remote/ajaxPeriod';

const AlertClosePeriod = ({show, handleClose}) => {

    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();


    const confirm = async()=>{
        setLoading(true);
        const server_response = await ajaxPeriod.closePeriod();
        setLoading(false);
        if(server_response.status === "OK"){
            setNotify(<Notification type='success' message={server_response.message}/>)
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>)
        }
        handleClose();
    }

    return (
        <BsModal
            show={show}
            onClose={handleClose}
            title="Closing Financial Period"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirm}>
                        Yes, Close Period
                    </button>
                    </>}
                </>
            }
        >


            <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{fontSize: '17px'}}>Are you sure you want to close balances for the current financial period ? </h5>

                <p className="mb-4 mt-2 text-secondary">
                <b>Note: </b> Please make sure you have configured the special account, EQ_OPENING_BALANCE, before closing the period. The income statement balance will be transferred to this account.
                </p>
           
            </div>
          

        </BsModal>
    );
};

export default AlertClosePeriod;
